export default (context, payload) => {
    context.select = payload.select
    context.alert.status = payload.status
    context.overlay = payload.overlay
}